import { UpdateArticleFeedbackParameters } from './types';

export const validatePatchArticleFeedbackParameters = (
  parameters: UpdateArticleFeedbackParameters,
) => {
  const articleId = parameters?.articleId;
  const feedbackId = parameters?.feedbackId;
  const body =
    parameters?.suggestedReasons?.length || parameters.writtenFeedback;

  if (!articleId || !feedbackId || !body) {
    return new Error(
      'Missing one or more of the required properties: articleId, feedbackId, and suggestedReasons or writtenFeedback',
    );
  }

  return undefined;
};
